<template>
  <div :class="classes" :style="styles">
    <slot />
  </div>
</template>

<script>
// Cor do titulo: Configuração via sitecore com o código da fonte
export default {
  name: 'cText',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    size: {
      type: String,
      default: 'lg',
      description: '(xs / sm / md / lg / xl)',
    },
    weight: {
      type: String,
      default: 'lighter',
      description: '(bolder / lighter / normal)',
    },
    align: {
      type: String,
      default: 'left',
    },
    tooltipBackground: {
      type: String,
      default: '#9ddda9',
    },
    tooltipColor: {
      type: String,
      default: '#000',
    },
    textReceivingTooltipColor: {
      type: String,
      default: '#989FA7',
    },
    textReceivingTooltipHoverColor: {
      type: String,
      default: '#333333',
    },
  },
  data() {
    return {
      hasTooltip: false,
    }
  },
  computed: {
    classes() {
      return [
        'c-text',
        `c-text--${this.size}`,
        `c-text--${this.weight}`,
        `c-text--${this.align}`,
      ]
    },
    styles() {
      const baseStyles = {
        color: this.color,
      }

      if (!this.hasTooltip) return baseStyles

      return {
        ...baseStyles,
        '--tooltipBackground': this.tooltipBackground,
        '--tooltipColor': this.tooltipColor,
        '--textReceivingTooltipColor': this.textReceivingTooltipColor,
        '--textReceivingTooltipHoverColor': this.textReceivingTooltipHoverColor,
      }
    },
  },
  mounted() {
    this.checkTooltipClass()
  },
  methods: {
    checkTooltipClass() {
      this.hasTooltip =
        this.$el.querySelector('.tooltip-text') !== null

      this.$emit('tooltip-status', this.hasTooltip)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-text {
  position: relative;
  display: inline-block;
  color: var(--textReceivingTooltipColor);
  font-weight: 700;

  &:hover {
    cursor: pointer;
    color: var(--textReceivingTooltipHoverColor);

    &::after {
      content: attr(data-tooltip-msg);
      font-size: 14px;
      background-color: var(--tooltipBackground);
      color: var(--tooltipColor);
      text-align: center;
      border-radius: 4px;
      padding: 5px;
      position: absolute;
      display: flex;
      justify-content: center;
      z-index: 9999;

      @media screen and (min-width: 768px) {
        min-width: 130px;
      }

      @media screen and (min-width: 1024px) {
        min-width: 200px;
      }
    }
  }
}

.c-text {
  display: flex;
  letter-spacing: -0.42px;
  position: relative;

  &--xs {
    font-size: 14px;
    line-height: 18px;
    position: relative;
  }

  &--sm {
    font-size: 16px;
    line-height: 20px;
    position: relative;
  }

  &--md {
    font-size: 18px;
    line-height: 22px;
    position: relative;
  }

  &--lg {
    font-size: 20px;
    line-height: 24px;
    position: relative;
  }

  &--xl {
    font-size: 22px;
    line-height: 26px;
    position: relative;
  }

  &--bolder {
    font-weight: bolder;
  }

  &--lighter {
    font-weight: lighter;
  }

  &--normal {
    font-weight: normal;
  }

  &--left {
    text-align: left;
    justify-content: flex-start;
  }

  &--center {
    text-align: center;
    justify-content: center;
  }

  &--right {
    text-align: right;
    justify-content: flex-end;
  }
}
</style>
